export default [
  {
    name: 'video',
    path: '/video/videoList',
    component: () => import('@/views/video/videoManange.vue'),
    meta: {
      title: '视频管理列表'
    }
  }
]
